export const popoverSx = {
  pointerEvents: 'none',
  '& .MuiPopover-paper': {
    pointerEvents: 'auto',
    padding: '12px',
    maxWidth: '500px',
    fontSize: '14px',
    color: 'var(--main-color)',
    backgroundColor: 'var(--secondary-color)',
    whiteSpace: 'pre-line',
  },
};

export const helpButtonSx = {
  padding: '2px',
  color: 'var(--secondary-color)',
  '&:hover': {
    color: 'var(--primary-color)',
    backgroundColor: 'transparent',
  },
};
